import './customer-info.scss';

import { forEach, keys } from 'lodash';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { DateSource } from '@shared/app/scripts/services/date-source';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { LegacyCustomer } from '@pos/app/scripts/services/legacy-consumer';
import { LocationManager } from '@shared/app/scripts/services/location-manager';
import { Mask } from '@core/app/scripts/services/mask';
import { Moment } from '@shared/app/scripts/vendor/moment';
import { PosSearch } from '@pos/app/scripts/services/pos-search';
import { Route } from '@pos/app/scripts/services/route';
import { Utility } from '@core/app/scripts/services/utility';

/*
 * Component responsible for /customer-info route.
 */
angular
  .module('posApp')
  .directive(
    'customerInfo',
    (
      CustomerModel,
      broadcaster: Broadcaster,
      customerInfoFilter,
      customerInfoFilterOptions,
      dateSource: DateSource,
      displayMessage: DisplayMessage,
      legacy,
      legacyCustomer: LegacyCustomer,
      loadCustomerInfo,
      locationManager: LocationManager,
      mask: Mask,
      moment: Moment,
      navigateTo: NavigateTo,
      pos,
      posSearch: PosSearch,
      route: Route,
      salesCalculations,
      translate: ng.translate.ITranslateService,
      utility: Utility,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./customer-info.html').default,

      link: function ($scope: any) {
        const $translate = translate;

        const allText = $translate.instant('All');

        $scope.param = route.param;

        $scope.customerInfoFilter = customerInfoFilter;

        $scope.pageHeader = '';
        $scope.months = [
          {
            value: null,
            month: allText,
          },
        ];
        $scope.years = [
          {
            value: null,
            year: allText,
          },
        ];

        $scope.filterPeriod = '';
        $scope.listSelected = 'G';
        $scope.pageRef = '';
        $scope.types = customerInfoFilterOptions;
        $scope.datebuff = '';
        $scope.customerId = '';
        $scope.selected = -1;
        $scope.smartListSales = [];
        $scope.smartListCoupons = [];
        $scope.smartListReceipts = [];
        $scope.customerToEdit = {};
        $scope.openAddressesPopup = false;
        $scope.openContactsPopup = false;
        $scope.openPropertiesPopup = false;
        $scope.listIndex = -1;
        $scope.addressesCopy = {};
        $scope.contactsCopy = {};
        $scope.propertiesCopy = {};
        $scope.salesHistoryList = [];
        $scope.couponsHistoryList = [];
        $scope.receiptHistoryList = [];
        $scope.selectedCustomer = {};
        $scope.warehouses = [];
        $scope.dataType = ['Text', 'Date', 'Numeric', 'Dropdown', 'Checkbox'];
        customerInfoFilter.warehouseId = locationManager.current.wh;

        function loadCustomer() {
          legacyCustomer.get($scope.customerId).then((data) => {
            if (angular.isObject(data)) {
              $scope.selectedCustomer = data;
              mask.hide();
            } else {
              // TODO Reevaluate this logic since we have addNew customer in place now
              // User should know why we DO have the requested customerId but we do not return anything

              // If no customer is loaded send user back to previous page
              if (loadCustomerInfo.pageRef) {
                navigateTo(loadCustomerInfo.pageRef);
              }
            }
          });
        }

        $scope.setSelectList = (list: any) => {
          if (list === 'G') {
            $scope.pageHeader = $translate.instant('General');
            $scope.listSelected = list;
            if ($scope.param === 'add-new') {
              $scope.pageHeader = $translate.instant('CreateNewCustomer');
            }
          } else if (list === 'S') {
            $scope.pageHeader = $translate.instant('Sales');
            $scope.loadCustomerSalesHistory().then(() => {
              $scope.listSelected = list;
            });
          } else if (list === 'C') {
            $scope.pageHeader = $translate.instant('Coupons');
            $scope.loadCustomerCouponHistory($scope.selectedCustomer._id).then(
              () => {
                $scope.listSelected = list;
              },
              () => {
                mask.hide();

                const message = $translate.instant('Not found');
                displayMessage.message(message);
              },
            );

            $scope.listSelected = list;
          } else if (list === 'Z') {
            $scope.pageHeader = $translate.instant('Receipts');
            $scope.loadCustomerTransactionHistory().then((response) => {
              $scope.listSelected = list;
            });
          }
        };

        // ngOnInit

        //Store months and years in arrays for the dropdowns
        const now = dateSource.now();

        for (let m = 1; m < 13; m++) {
          $scope.months.push({
            value: m,
            month: m.toString().length === 1 ? '0' + m : m.toString(),
          });
        }

        for (let y = 0; y < 20; y++) {
          $scope.years.push({
            value: moment(now).subtract(y, 'year').year(),
            year: moment(now).subtract(y, 'year').year(),
          });
        }

        $scope.warehouses = [
          {
            id: null,
            name: allText,
          },
        ];

        forEach(locationManager.all, (obj) => {
          $scope.warehouses.push({
            id: obj.wh,
            name: obj.name,
          });
        });

        if ($scope.param === 'add-new') {
          $scope.selectedCustomer = new CustomerModel();
          $scope.selectedCustomer._id = utility.uuid();
        } else {
          $scope.customerId = $scope.param;

          $scope.salesHistoryList = [];
          $scope.couponsHistoryList = [];
          $scope.receiptHistoryList = [];

          if ($scope.customerId) {
            loadCustomer();
          }
        }
        $scope.setSelectList('G');

        /*
         * Loads the individual barcodes from each sales transaction
         */
        $scope.loadCustomerSalesHistory = () => {
          displayMessage.showLoading();
          return legacyCustomer
            .loadCustomerSalesHistory(
              $scope.customerId,
              $scope.customerInfoFilter.month,
              $scope.customerInfoFilter.year,
            )
            .then((data) => {
              $scope.salesHistoryList = data;
              mask.hide();
            }, mask.hide);
        };

        $scope.loadCustomerTransactionHistory = () => {
          displayMessage.showLoading();

          return legacyCustomer
            .loadCustomerTransactionHistory(
              $scope.customerId,
              $scope.customerInfoFilter.combined.type,
              $scope.customerInfoFilter.warehouseId,
              $scope.customerInfoFilter.month,
              $scope.customerInfoFilter.year,
              $scope.customerInfoFilter.combined?.status,
            )
            .then((response) => {
              $scope.receiptHistoryList = response.data?.data;
              mask.hide();
            }, mask.hide);
        };

        $scope.loadCustomerCouponHistory = () => {
          displayMessage.showLoading();

          return legacyCustomer
            .loadCustomerCouponHistory($scope.selectedCustomer._id)
            .then(
              (customerCouponHistory) => {
                $scope.couponsHistoryList = customerCouponHistory;
                mask.hide();
              },
              () => {
                /* test lines
                $scope.couponsHistoryList = [
                  {
                    type: 'KC',
                    status: 'OPEN',
                    number: '+ME2U0FF8WKUQ',
                  },
                ];*/
                mask.hide();
              },
            );
        };

        /*
         * This method is used as a filter on the customer coupon grid
         */
        $scope.filterCoupons = (val) => {
          // No date is selected, so show all items
          if (
            !$scope.customerInfoFilter.month &&
            !$scope.customerInfoFilter.year
          ) {
            return true;
          }

          if (val.date) {
            let month = '',
              year = '',
              dateKey = '';

            if ($scope.customerInfoFilter.year) {
              year = $scope.customerInfoFilter.year + '-';
            }

            if ($scope.customerInfoFilter.month) {
              month = ('0' + $scope.customerInfoFilter.month).slice(-2) + '-';
            }

            dateKey = `${year}${month}`;

            // expected date format 2021-09-27
            return val.date.includes(dateKey);
          }

          return true;
        };

        /*
         * The following methods are used in the coupon grids to translate dynamic values
         */
        $scope.translateCouponStatus = (status) => {
          if (status) {
            // is called with - OPEN & REDEEMED
            return $translate.instant(status);
          }
          return '';
        };

        $scope.translateCouponType = (row) => {
          if (row.type) {
            return salesCalculations.lineType(row);
          }
          return '';
        };

        /*
         * This method is used as a filter on the customer receipts grid
         */
        $scope.filterTransactions = (val) => {
          let filter = true;

          if (filter) {
            if ($scope.nr) {
              filter =
                val.nr.indexOf($scope.nr.toUpperCase()) != -1 ? true : false;
            }
          }

          if (filter) {
            if ($scope.amount) {
              if ($scope.type === 9) {
                // TODO these filters do not take into account decimal entries ie 12,98
                filter =
                  val.payments.consignment.toString().indexOf($scope.amount) !=
                  -1
                    ? true
                    : false;
              } else {
                // TODO these filters do not take into account decimal entries ie 12,98
                filter =
                  salesCalculations
                    .total(val)
                    .toString()
                    .indexOf($scope.amount) != -1
                    ? true
                    : false;
              }
            }
          }

          return filter;
        };

        $scope.selectCurrentLine = (currentLine) => {
          $scope.toggleSelect(currentLine.id);
        };

        $scope.selectReceipt = (receipt) => {
          // Before opening the receipt view, set the selected tab and header to the
          // receipts tab so the Receipts button is still selected when we navigate
          // back from the receipt.
          $scope.setSelectList('Z');
          pos.selectReceipt(receipt, `pos.route#customer-info/${$scope.param}`);
        };

        $scope.getTransactionTotal = (transaction) =>
          salesCalculations.total(transaction);

        $scope.selectCurrentCoupon = (coupon) => {
          if (coupon.status && coupon.status.toUpperCase() == 'OPEN') {
            navigateTo('pos.route#pos');
            // TODO find more precise method to be called form here
            posSearch.scan('+' + coupon.number);
          } else if (
            coupon.status &&
            coupon.status.toUpperCase() == 'REDEEMED'
          ) {
            const message = $translate.instant('AlreadyRedeemed');
            displayMessage.message({
              message: message,
              type: 'info',
              callback: null,
            });
          }
        };

        $scope.isCouponBlockable = (coupon) => {
          return (
            (coupon.type == 'K' ||
              coupon.type == 'KA' ||
              coupon.type == 'KC') &&
            coupon.status == 'OPEN'
          );
        };

        $scope.isCouponUnblockable = (coupon) => {
          return coupon.status == 'BLOCKED';
        };

        $scope.perMissionToUnblock = () => {
          return !!pos.config.acls.pos_unblock_coupons;
        };

        $scope.blockCoupon = (index) => {
          if (!$scope.isCouponBlockable($scope.smartListCoupons[index])) {
            return;
          }

          $scope.smartListCoupons[index].status = 'PROCESSING';

          legacy
            .blockCoupon($scope.smartListCoupons[index].number)
            .then((response) => {
              // Update the coupon status so we can update the UI without
              // waiting for FoxPro to be ready.
              $scope.smartListCoupons[index].status = 'BLOCKED';
            });
        };

        $scope.unblockCoupon = (index) => {
          if (!$scope.isCouponUnblockable($scope.smartListCoupons[index])) {
            return;
          }
          $scope.smartListCoupons[index].status = 'PROCESSING';
          legacy
            .unblockCoupon($scope.smartListCoupons[index].number)
            .then((response) => {
              // Update the coupon status so we can update the UI without
              // waiting for FoxPro to be ready.
              $scope.smartListCoupons[index].status = 'OPEN';
            });
        };

        $scope.isTransactionCustomer = () =>
          pos.transaction && pos.transaction.customer === null;

        $scope.toggleSelect = (ind) => {
          $scope.selectedLine = ind;
        };

        $scope.getClass = (ind) => {
          if (ind == $scope.selectedLine) {
            return 'ui-btn-active';
          } else {
            return '';
          }
        };

        $scope.cleanText = () => {
          $scope.selectedCustomer.remarks =
            $scope.selectedCustomer.remarks.replace('\n', ' ');
        };

        const resetCustomerFormState = () => {
          $scope.customerInfo.$setPristine();
        };

        const updateTransactionCustomerIfNeeded = () => {
          if (
            pos.transaction &&
            pos.transaction.customer &&
            pos.transaction.customer.id &&
            pos.transaction.customer.id == $scope.selectedCustomer._id
          ) {
            broadcaster.send('customerSelected', $scope.selectedCustomer);
          }
        };

        // save current customer to the server
        $scope.saveData = () => {
          displayMessage.showLoading();
          legacyCustomer.save($scope.selectedCustomer).then((response) => {
            mask.hide();

            const message = $translate.instant('DataSaveSuccess');
            displayMessage.message({
              message: message,
              type: 'info',
              callback: null,
              mini: true,
            });

            updateTransactionCustomerIfNeeded();
            resetCustomerFormState();

            if ($scope.param === 'add-new') {
              $scope.customerId = response.data.data[0];
              navigateTo('pos.route#customer-info/' + $scope.customerId);
              loadCustomer();
            }
          }, mask.hide);
        };

        $scope.selectCustomer = () => {
          broadcaster.send('customerSelected', $scope.selectedCustomer);
          pos.selectedMenu = 1;
          navigateTo('pos.route#pos');
        };

        //Select the current list item and make a copy, this is used in the closePopup
        $scope.selectList = (list, item, index) => {
          //The listIndex is used to
          $scope.listIndex = index;
          switch (list) {
            case 'address':
              //Select the current address
              $scope.addressesCopy = angular.copy(item);
              $scope.openAddressesPopup = true;
              break;

            case 'contact':
              //Select the current property
              $scope.contactsCopy = angular.copy(item);
              $scope.openContactsPopup = true;
              break;
            case 'property':
              //Select the current property
              $scope.propertiesCopy = angular.copy(item);
              $scope.openPropertiesPopup = true;
              break;
          }
        };

        //Add new item to the address, phone or email list
        $scope.addNewItem = (list) => {
          //
          //For the time being do not add new stuff yet
          //SWUI-1086
          const message = $translate.instant('FeatureNotActiveYet');
          displayMessage.message(message);
          return;
        };

        //Add new item to the address or bank list
        $scope.delItem = (list, index) => {
          //
          //For the time being do not add new stuff yet
          //SWUI-1086
          const message = $translate.instant('FeatureNotActiveYet');
          displayMessage.message(message);
          return;
        };

        //Close popups
        $scope.popupClose = (list, action) => {
          //Reset list
          if (action == 'cancel') {
            if ($scope.selectedCustomer[list] && $scope.listIndex >= 0) {
              //Test the copy obj for values, if no values this is a new entry
              if (keys($scope[list + 'Copy']).length === 0) {
                $scope.delItem(list, $scope.listIndex);
              } else {
                //Restore the previous item on a cancel
                $scope.selectedCustomer[list][$scope.listIndex] =
                  $scope[list + 'Copy'];
                $scope[list + 'Copy'] = {};
              }
            }
          }

          // opePopups has to be set to false again otherwise it will not close
          $scope.openAddressesPopup = false;
          $scope.openContactsPopup = false;
          $scope.openPropertiesPopup = false;
          $scope.listIndex = -1;
        };

        $scope.customerInfoActivate = (firstTime) => {};

        $scope.getSelectedList = (list) => $scope.listSelected == list;

        $scope.getListClass = (list) => {
          if (list === $scope.listSelected) {
            return 'ui-btn-active';
          }

          return '';
        };

        $scope.exitForm = () => {
          resetCustomerFormState();

          $scope.openAddressesPopup = false;
          $scope.openContactsPopup = false;
          $scope.openPropertiesPopup = false;
          $scope.addressesCopy = {};
          $scope.contactsCopy = {};
          $scope.propertiesCopy = {};

          navigateTo(loadCustomerInfo.pageRef);
        };
      },
    }),
  );
